// extracted by mini-css-extract-plugin
export default {"label":"IL1kijHcl4j3z4rCAv4M"};